import { render } from "./wdmSmallCheckmark.vue?vue&type=template&id=ffe21224&scoped=true"
import script from "./wdmSmallCheckmark.vue?vue&type=script&lang=js"
export * from "./wdmSmallCheckmark.vue?vue&type=script&lang=js"

import "./wdmSmallCheckmark.vue?vue&type=style&index=0&id=ffe21224&scoped=true&lang=css"

import exportComponent from "/Users/michael/Desktop/Development/vue/login/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe21224"]])

export default __exports__